import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Page-css/ClientProjectTable.css";
import { useDispatch, useSelector } from "react-redux";
import { setProjects } from "../../REDUX_CLIENT/projectList/cltprojectListActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCaretUp,
  faCaretDown,
  faBarsProgress,
  faMobileScreen,
} from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../../Context/UserContext";
import ClientNavbar from "./ClientNavbar";
import ClientNavbar2 from "./ClientNavbar2";
import { toast } from "react-toastify";
import { faCalendarDays, faUser } from "@fortawesome/free-regular-svg-icons";
import { Icon } from "@iconify/react";
import { url } from '../../constants/url'
import ClientNavbar1 from "./ClientNavbar1";
import AssignProject from "../Modal/AssignProject";

const ClientProjectTable = () => {

  const { userRole, logout, isSidebarCollapsed, userPermission, company } = useAuth();

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const [searchQuery, setSearchQuery] = useState("");
  const [inputFocused, setInputFocused] = useState(false);
  const [selectedProjectIds, setSelectedProjectIds] = useState([]);

  const [openClientDropdowns, setOpenClientDropdowns] = useState(false);
  const [selectedSubFilter, setSelectedSubFilter] = useState()
  const [openSubDropdown, setOpenSubDropdown] = useState(false);


  const initialFilter = location.state?.filter || "All";
  const [selectedProFilter, setSelectedProFilter] = useState(initialFilter);

  const [expandProject, setExpandProject] = useState(null);
  const [clientProjectData, setClientProjectData] = useState(null);

  const [leadId, setLeadId] = useState("");
  const [projectId, setProjectId] = useState("");
  const [leadNameError, setLeadNameError] = useState("");
  const [projectNameError, setProjectNameError] = useState("");

  const [developerSuggestions, setDeveloperSuggestions] = useState([]);
  const [ownerSuggestions, setOwnerSuggestions] = useState([])
  const [filteredDeveloperSuggestions, setFilteredDeveloperSuggestions] = useState([]);

  const [openAssignTeamLead, setOpenAssignTeamLead] = useState(false);

  const projects = useSelector((state) => state.cltprojectList.projects);

  const filterProRef = useRef(null);
  const filterSubProRef = useRef(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [projectsPerPage, setProjectsPerPage] = useState(25);
  const [assignSidebar, setAssignSidebar] = useState(false)


  const [openDropDown, setOpenDropDown] = useState(false);
  const dropdownRef = useRef(null);

  const options = [25, 50, 75, 100];


  // Refer project.js file for backend code
  const fetchClientProject = async () => {
    try {
      const response = await fetch(
        `${url}/fetchclientprojectlist`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
        }
      );
      const clientProject = await response.json();

      const sortedProject = clientProject.sort((a, b) => {
        const statusOrder = ["inprogress", "retesting", "completed"];
        const statusA = a.status.toLowerCase();
        const statusB = b.status.toLowerCase();
        return statusOrder.indexOf(statusA) - statusOrder.indexOf(statusB);
      });

      dispatch(setProjects(sortedProject));

      if (response.status === 440) {
        logout();
        toast.error("User logout due to inactivity", {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
        return;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDevelopers = async () => {
    try {
      const response = await fetch(`${url}/fetchteamlead`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      });

      const data = await response.json();
      setDeveloperSuggestions(data.lead);
      setOwnerSuggestions(data.owner)
      if (response.status === 440) {
        logout();
        toast.error("User logout due to inactivity", {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
        return;
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchClientProject();
    fetchDevelopers();
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "NA";

    const date = new Date(dateString);
    if (isNaN(date)) return "NA";

    const options = { day: "2-digit", month: "2-digit", year: "numeric" };
    return date.toLocaleDateString("en-GB", options);
  };


  const handleSearchInput = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };

  const filteredProjects = projects.filter((project) => {
    const matchesSearch =
      (project.projectName || "")
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) ||
      (project.applicationType || "")
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) ||
      (project.status || "")
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) ||
      (project.developerLeadName || "")
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) ||
      (project.clientManagerName || "")
        .toLowerCase()
        .includes(searchQuery.toLocaleLowerCase()) ||
      (project.applicationOrRegularEntity || "")
        .toLowerCase()
        .includes(searchQuery.toLocaleLowerCase())
    let matchesFilter = true;

    if (selectedProFilter === "All") {
      matchesFilter = true;

    } else if (selectedProFilter === "Application Type") {
      if (!selectedSubFilter || selectedSubFilter === "--Select--") {
        // second dropdown not picked → show all
        matchesFilter = true;
      } else {
        matchesFilter = project.applicationType === selectedSubFilter;
      }

    } else if (selectedProFilter === "Status") {
      if (!selectedSubFilter || selectedSubFilter === "--Select--") {
        matchesFilter = true;
      } else {
        matchesFilter = project.status === selectedSubFilter;
      }

    } else if (selectedProFilter === "Project Lead") {
      if (!selectedSubFilter || selectedSubFilter === "--Select--") {
        matchesFilter = true;
      } else {
        matchesFilter = project.developerLeadName === selectedSubFilter;
      }
    } else if (selectedProFilter === "Entity") {
      if (!selectedSubFilter || selectedSubFilter === "--Select--") {
        matchesFilter = true;
      } else {
        matchesFilter = project.applicationOrRegularEntity === selectedSubFilter;
      }
    } else if (selectedProFilter === "Project Owner") {
      if (!selectedSubFilter || selectedSubFilter === "--Select--") {
        matchesFilter = true
      } else {
        matchesFilter = project.clientManagerName === selectedSubFilter;
      }
    }

    return matchesSearch && matchesFilter;
  });


  const getTotalPages = () => {
    return Math.ceil((filteredProjects ?? []).length / projectsPerPage);
  };

  const startIndex = (currentPage - 1) * projectsPerPage;
  const endIndex = startIndex + projectsPerPage;

  const getPageProjects = () => {
    if (!filteredProjects) {
      return [];
    }
    const slicedProjects = filteredProjects.slice(startIndex, endIndex);
    return slicedProjects.map((project, index) => ({
      ...project,
      slNo: startIndex + index + 1,
    }));
  };

  const handlePreviousPage = () => {
    setCurrentPage((prevPage) => (prevPage > 1 ? prevPage - 1 : prevPage));
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) =>
      prevPage < getTotalPages() ? prevPage + 1 : prevPage
    );
  };

  const handlePageSizeChange = (e) => {
    setProjectsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handleSelect = (value) => {
    setProjectsPerPage(value);
    setOpenDropDown(false);
    setCurrentPage(1);
  };

  const getStatus = (status) => {
    if (status === "Inprogress") {
      return "ongoing";
    } else if (status === "Retesting") {
      return "retesting";
    } else if (status === "Completed") {
      return "completed";
    }
    return "";
  };

  // Refer project.js file for backend code
  const handleAddDeveloper = async () => {
    try {
      const response = await fetch(`${url}/assignteamlead`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          userId: leadId,
          projectId: projectId,
        }),
      });

      if (response.status === 200) {
        setOpenAssignTeamLead(false);
        fetchClientProject();
        setLeadId("");
        setProjectId("");
        toast.success("Project assigned successfully", {
          position: "top-center",
          autoClose: 3000,
          pauseOnHover: false,
        });
      }

      if (response.status === 401) {
        toast.error("Only project owner can assign", {
          position: "top-center",
          autoClose: 3000,
          pauseOnHover: false,
        });
      }
      if (response.status === 440) {
        logout();
        toast.error("User logout due to inactivity", {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
        return;
      }
    } catch (error) {
      console.log(error);
      toast.error("Internal Server Error", {
        position: "top-center",
        autoClose: 3000,
        pauseOnHover: false,
      });
    }
  };


  const handleClickOutClient = (event) => {
    if (filterProRef.current && !filterProRef.current.contains(event.target)) {
      setOpenClientDropdowns(false);
    }
  };
  const handleClickOutSubClient = (event) => {
    if (filterSubProRef.current && !filterSubProRef.current.contains(event.target)) {
      setOpenSubDropdown(false);
    }
  };

  const getRandomColor = (text) => {
    const colors = [
      "#FF5733",
      "#33c5ff",
      "#5733FF",
      "#FF33A8",
      "#2E89E4",
      "#2680c5",
      "#d01717",
      "#b14d00",
      "#1e6461",
      "000000",
    ];
    const hash = [...text].reduce((acc, char) => acc + char.charCodeAt(0), 0);
    return colors[hash % colors.length];
  };

  useEffect(() => {
    if (openClientDropdowns) {
      document.addEventListener("mousedown", handleClickOutClient);
    } else {
      document.removeEventListener("mousedown", handleClickOutClient);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutClient);
    };
  }, [openClientDropdowns]);

  useEffect(() => {
    if (openSubDropdown) {
      document.addEventListener("mousedown", handleClickOutSubClient);
    } else {
      document.removeEventListener("mousedown", handleClickOutSubClient);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutSubClient);
    };
  }, [openSubDropdown]);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropDown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="client-table-list-dash">
      <div>
        <div className='client_navabr1'>
          <ClientNavbar1 />
        </div>
        <div className='navbar_second'><ClientNavbar2 /></div>
      </div>
      <div className='wrap_navbar_dashboard'>
        <div className={isSidebarCollapsed ? 'clientdash-navbar' : 'clientdash_close_navbar'}>
          <ClientNavbar />
        </div>
        <div className="project-table-container">
          <div className="project-table-header-container">
            <div className="project-table-header-content">
              <h2 className="project-table-header">View and manage all ongoing and completed penetration testing projects.
              </h2>
              <div className="project-table-search-input-btn-container">
                <div className='manage_user_filter'>
                  <label>Group by</label>

                  <div className='manage_user_filter_select' style={{ position: 'relative', display: 'flex', gap: '1rem' }}>

                    <div style={{ position: 'relative' }}>
                      <div
                        className="custom-select-client"
                        onClick={() => setOpenClientDropdowns((prev) => !prev)}>
                        <span style={{ marginRight: 8, color: '#202123CC' }}>{selectedProFilter}</span>
                        <Icon
                          icon={openClientDropdowns ? "ic:round-arrow-drop-up" : "ic:round-arrow-drop-down"}
                          width="24"
                          height="24"
                          style={{ color: "#E76A34" }}
                        />
                      </div>

                      {openClientDropdowns && (
                        <ul style={{ width: "150px" }} className="custom-dropdown" ref={filterProRef}>
                          {["All", "Project Owner", "Project Lead", "Application Type", "Status", ...(company === "360 One" ? ["Entity"] : [])].map(option => (
                            <li
                              key={option}
                              className={selectedProFilter === option ? "selected" : ""}
                              onClick={() => {
                                setSelectedProFilter(option);
                                setOpenClientDropdowns(false);
                                setSelectedSubFilter("--Select--");
                              }}>
                              {option}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>


                    {(selectedProFilter === "Application Type" ||
                      selectedProFilter === "Status" ||
                      selectedProFilter === "Project Lead" ||
                      selectedProFilter === "Entity" ||
                      selectedProFilter === "Project Owner") && (
                        <div style={{ position: 'relative' }}>
                          <div
                            className="custom-select-client"
                            onClick={() => setOpenSubDropdown((prev) => !prev)}
                          >
                            <span style={{ marginRight: 8, color: '#202123CC' }}>
                              {selectedSubFilter || "--Select--"}
                            </span>
                            <Icon
                              icon={openSubDropdown ? "ic:round-arrow-drop-up" : "ic:round-arrow-drop-down"}
                              width="24"
                              height="24"
                              style={{ color: "#E76A34" }}
                            />
                          </div>

                          {openSubDropdown && (
                            <ul className="custom-dropdown" ref={filterSubProRef}>
                              {(
                                selectedProFilter === "Application Type"
                                  ? ["WEB", "API", "ANDROID", "IOS", "ANDROID & IOS", "Source Code Review", "Desktop App", "VA Scan", "Configuration Review", "External Network Penetration Testing", "Internal Network Penetration Testing"]
                                  : selectedProFilter === "Status"
                                    ? ["Pending", "Inprogress", "Retesting", "Completed"]
                                    : selectedProFilter === "Entity"
                                      ? [
                                        "360 ONE AMC - MF",
                                        "360 ONE AMC - PMS",
                                        "360 ONE PMS",
                                        "360 ONE AAM",
                                        "360 ONE Prime",
                                        "360 ONE Wealth",
                                        "360 ONE DSL",
                                        "360 IATSL",
                                        "360 ONE AMC"]
                                      : selectedProFilter === "Project Owner"
                                        ? ownerSuggestions.map(owner => owner.name) : (() => {
                                          return developerSuggestions.map(dev => dev.name);
                                        })()
                              ).map(option => (
                                <li
                                  key={option}
                                  className={selectedSubFilter === option ? "selected" : ""}
                                  onClick={() => {
                                    setSelectedSubFilter(option);
                                    setOpenSubDropdown(false);
                                  }}
                                >
                                  {option}
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                      )}



                  </div>
                </div>

                <div className="project-table-search-input">
                  <Icon icon="ic:round-search" width="20" height="20" style={{ color: "#E76A34", marginRight: "8px", marginLeft: "8px" }} />
                  <input
                    className="search-input"
                    type="text"
                    placeholder="Search by project, application type or status..."
                    onChange={handleSearchInput}
                    value={searchQuery}
                    onFocus={() => setInputFocused(true)}
                    onBlur={() => setInputFocused(false)}
                    style={{
                      padding: '5px'
                    }}
                  />
                </div>
                {(userPermission === 'level 1' || userPermission === "level 2") ? (
                  <div className="project-table-assign-btn">
                    <button
                      onClick={() => setAssignSidebar(true)}
                      style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
                    >
                      <Icon icon="tdesign:user-checked" width="18" height="18" />
                      <span>Assign Lead</span>
                    </button>

                  </div>
                ) : ''}

              </div>
            </div>
            <div className="project-pagination_table">
              <div className="project-wrap-pagination-data">
                <div className="table_size">
                  <div className="wrap_dropdown_project_table" ref={dropdownRef}>
                    <button
                      onClick={() => setOpenDropDown(!openDropDown)}
                      className="dropdown-toggle"
                    >
                      {projectsPerPage}{" "}
                      {openDropDown ? (
                        <span style={{ fontSize: "14px", marginLeft: "5px" }}>
                          <FontAwesomeIcon icon={faCaretUp} />
                        </span>
                      ) : (
                        <span style={{ fontSize: "14px", marginLeft: "5px" }}>
                          <FontAwesomeIcon icon={faCaretDown} />
                        </span>
                      )}
                    </button>

                    {openDropDown && (
                      <div className="dropdown-menu-project-list">
                        <ul>
                          {options.map((option) => (
                            <li key={option} onClick={() => handleSelect(option)}>
                              {option}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>

                  {filteredProjects.length === 0 ? (
                    ""
                  ) : (
                    <p>
                      {startIndex + 1} to{" "}
                      {Math.min(endIndex, filteredProjects.length)} of{" "}
                      {filteredProjects.length}
                    </p>
                  )}

                  {filteredProjects && (
                    <div className="wrap-pages_client">
                      <button
                        data-testid="previous_page"
                        onClick={handlePreviousPage}
                        disabled={currentPage === 1 || getTotalPages() === 1 || filteredProjects.length === 0}
                      >
                        <Icon icon="ep:arrow-left-bold" width="18" height="18" />
                      </button>

                      <p data-testid="current_clientpage">{currentPage}</p>

                      <button
                        data-testid="next_page"
                        onClick={handleNextPage}
                        disabled={currentPage === getTotalPages() || getTotalPages() === 1 || filteredProjects.length === 0}>
                        <Icon icon="ep:arrow-right-bold" width="18" height="18" />
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="project-table-main-container">
              <table>
                <thead className="project-table-main-container-header">
                  <tr>
                    <th>Sl No</th>
                    <th>Project Name</th>
                    {company === "360 One" && (
                      <th>Entity</th>
                    )}
                    {userPermission !== 'level 4' ? (
                      <th>Vulnerabilities</th>
                    ) : ''}

                    {userPermission !== 'level 3' && (
                      <th><Icon icon="proicons:person" width="16" height="16" />Project Lead</th>
                    )}

                    <th><Icon icon="formkit:date" width="16" height="16" />Start Date</th>
                    <th><Icon icon="formkit:date" width="16" height="16" />End Date</th>
                    <th><Icon icon="carbon:ibm-watsonx-code-assistant-for-enterprise-java-applications" width="16" height="16" />Application type</th>
                    <th><Icon icon="fluent:phone-status-bar-20-regular" width="16" height="16" /> Status</th>
                  </tr>
                </thead>
                <tbody className="project-table-main-container-body">
                  {filteredProjects.length === 0 ? (
                    <tr className="collapsetable">
                      <td colSpan="8">Projects Not Found....</td>
                    </tr>
                  ) : (
                    getPageProjects().map((project, index) => (
                      <tr key={index} style={{ cursor: 'pointer' }} >
                        <td onClick={() => navigate('/client_dashboard', { state: { projectId: project._id } })}>{index + 1}</td>
                        <td onClick={() => navigate('/client_dashboard', { state: { projectId: project._id } })}>{project.projectName}</td>
                        {
                          company === "360 One" && (
                            <td>{project.applicationOrRegularEntity}</td>
                          )
                        }
                        {userPermission !== 'level 4' ? (
                          <td className="vulnerabilities" onClick={() => navigate('/client_dashboard', { state: { projectId: project._id } })}>
                            {(
                              project.severitySummary?.Critical +
                              project.severitySummary?.High +
                              project.severitySummary?.Medium +
                              project.severitySummary?.Low +
                              project.severitySummary?.Info
                            ) === 0 ? (
                              <>0</>
                            ) : (
                              <>
                                {project.severitySummary?.Critical > 0 && (
                                  <>
                                    <span className="box box-critical"></span>{project.severitySummary?.Critical}
                                  </>
                                )}
                                {project.severitySummary?.High > 0 && (
                                  <>
                                    <span className="box box-high"></span>{project.severitySummary?.High}
                                  </>
                                )}
                                {project.severitySummary?.Medium > 0 && (
                                  <>
                                    <span className="box box-medium"></span>{project.severitySummary?.Medium}
                                  </>
                                )}
                                {project.severitySummary?.Low > 0 && (
                                  <>
                                    <span className="box box-low"></span>{project.severitySummary?.Low}
                                  </>
                                )}
                                {project.severitySummary?.Info > 0 && (
                                  <>
                                    <span className="box box-info"></span>{project.severitySummary?.Info}
                                  </>
                                )}
                              </>
                            )}
                          </td>
                        ) : ''}

                        {userPermission !== 'level 3' && (
                          <td>
                            {project.developerLeadName ? (
                              <>
                                <span
                                  style={{
                                    backgroundColor: getRandomColor(project.developerLeadName)
                                  }}
                                  className="name_initial"
                                >
                                  {project.developerLeadName.charAt(0).toUpperCase()}
                                </span>
                                {project.developerLeadName}
                              </>

                            ) : userPermission === "level 4" ? (
                              <span>Unassigned</span>
                            ) : (
                              <div className="project-table-assign-btn">
                                <button
                                  style={{ fontSize: '12px', padding: '6px 10px' }}
                                  onClick={() => setAssignSidebar(true)}
                                >
                                  Assign
                                </button>
                              </div>
                            )}
                          </td>
                        )}


                        <td onClick={() => navigate('/client_dashboard', { state: { projectId: project._id } })}>{formatDate(project.testStartDate)}</td>
                        <td onClick={() => navigate('/client_dashboard', { state: { projectId: project._id } })}>{formatDate(project.testEndDate)}</td>
                        <td onClick={() => navigate('/client_dashboard', { state: { projectId: project._id } })}>{project.applicationType}</td>
                        <td onClick={() => navigate('/client_dashboard', { state: { projectId: project._id } })}>
                          <span className={`status ${getStatus(project.status)}`}>
                            {project.status}
                          </span>
                        </td>
                      </tr>
                    ))
                  )}

                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>

      <AssignProject
        assignSidebar={assignSidebar}
        setAssignSidebar={setAssignSidebar}
        projectId={projectId}
        setProjectId={setProjectId}
        projects={projects}
        leadId={leadId}
        setLeadId={setLeadId}
        developerSuggestions={developerSuggestions}
        leadNameError={leadNameError}
        projectNameError={projectNameError}
        handleAddTeamLead={handleAddDeveloper}
      />
    </div>
  );
};

export default ClientProjectTable;